import React, { useEffect } from 'react';
import urlParse from 'url-parse';
import { IdProvider } from '@radix-ui/react-id';
import { builder } from '@builder.io/react';
import App from 'next/app';

import 'slick-carousel/slick/slick.css';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/neo.css';
import 'react-scale/components/ui/global.css';
import 'react-scale/components/ui/hubspot/forms/global.css';
import { TransformXContextProvider } from 'react-scale/lib/transformx/context';
import { BuilderProvider, fetchBuilderData } from 'react-scale/lib/context/builder';
import CookieBanner from 'react-scale/components/modules/cookie-banner';

const BUILDER_API_KEY = process.env.NEXT_PUBLIC_BUILDER_API_KEY;
builder.init(BUILDER_API_KEY);

export default function MyApp({ Component, pageProps, err, builderData, router }) {
  useEffect(() => {
    const { query } = urlParse(window.location.href, true);
    try {
      if (
        query.utm_campaign ||
        query.utm_source ||
        query.utm_medium ||
        query.utm_term ||
        query.utm_content
      ) {
        window.localStorage.setItem(
          'utm_params',
          JSON.stringify({
            utm_campaign: query.utm_campaign,
            utm_source: query.utm_source,
            utm_medium: query.utm_medium,
            utm_term: query.utm_term,
            utm_content: query.utm_content
          })
        );
      }
    } catch (error) {
      // NOTE: ignore error, using localStorage/sessionStorage is disabled in incognito.
    }
  }, []);

  return (
    <TransformXContextProvider>
      <IdProvider>
        <BuilderProvider data={builderData}>
          <Component {...pageProps} err={err} />
          {router.state?.pathname.startsWith('/ai-readiness-report') && <CookieBanner />}
          {/* <div id="ot-sdk-cookie-policy" /> */}
        </BuilderProvider>
      </IdProvider>
    </TransformXContextProvider>
  );
}

MyApp.getInitialProps = async ctx => {
  const app = await App.getInitialProps(ctx);
  const builderData = await fetchBuilderData(ctx);
  return {
    builderData,
    ...app
  };
};
